import { render, staticRenderFns } from "./ReceiptDialog.vue?vue&type=template&id=facc9dd0&scoped=true"
import script from "./ReceiptDialog.vue?vue&type=script&lang=js"
export * from "./ReceiptDialog.vue?vue&type=script&lang=js"
import style0 from "./ReceiptDialog.vue?vue&type=style&index=0&id=facc9dd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "facc9dd0",
  null
  
)

export default component.exports